import memoize from 'lodash/memoize';
import {z} from 'zod';

/**
 * {@link https://web.dev/priority-hints/ Priority hints} for {@link https://developer.mozilla.org/en-US/docs/Web/API/Request/priority Fetch requests}
 */
declare global {
    interface RequestInit {
        priority?: 'low' | 'medium' | 'high';
    }
}

export default async function fetchJSON<T = any>(
    url: RequestInfo,
    settings?: RequestInit,
    schema: z.Schema<T> = z.any()
) {
    const response = await fetch(url, {
        credentials: 'same-origin',
        ...settings,
    });

    try {
        const json = await response.json();

        const validation = schema.safeParse(json);

        if (validation.success) {
            return validation.data;
        } else {
            console.error('Failed Zod schema validation', json, validation.error);
            return json as T;
        }
    } catch (error) {
        console.error(error, url, settings);
        throw error;
    }
}

export const fetchJSONMemoized = memoize(fetchJSON, (url, settings) =>
    JSON.stringify([url, settings])
);
